/*
  UserReport/SingleViewUser.js - Creates a Single User view that allows Editing as well
*/

// NPM MODULES
import React, { useEffect } from 'react';
import NewUserEditForm from '../../account/users/NewUserEditForm';

import UserReportsFormattedMessages from '../../../messages/reports/UserReportsFormattedMessages';

const SingleViewUser = ({ selectedData, setPageTitle, errorHandler }) => {
  useEffect(() => {
    setPageTitle(UserReportsFormattedMessages.standardMessages);
  }, []);

  return <NewUserEditForm user={selectedData} errorHandler={errorHandler} />;
};

export default SingleViewUser;
